import { Component, Inject, forwardRef } from '@angular/core';

import { smoothlyMenu } from '../../app.helpers';
import { AppComponent } from 'app/app.component';
import { DevExtremeModule } from 'devextreme-angular';
import { RouterLink } from '@angular/router';
declare var jQuery: any;

@Component({
    selector: 'topnavbar',
    templateUrl: 'topnavbar.template.html',
    imports: [DevExtremeModule, RouterLink],
    standalone: true,
})
export class TopNavbarComponent {
    constructor(@Inject(forwardRef(() => AppComponent)) public app: AppComponent) {}

    toggleNavigation(): void {
        jQuery('body').toggleClass('mini-navbar');
        smoothlyMenu();
    }
}
